<template>
    <component :is="tag">
        <rkm-row
            v-if="!hideFilters"
            class="mb-2"
        >
            <rkm-col cols="6">
                <rkm-form-group
                    class="my-0"
                    label-cols="auto"
                    label="Buscar"
                >
                    <rkm-input-group>
                        <rkm-form-input
                            placeholder="Digite para buscar"
                            v-model="context.filter"
                        />

                        <template slot="append">
                            <rkm-button
                                :disabled="!context.filter"
                                @click="context.filter = ''"
                            >
                                Limpar
                            </rkm-button>
                        </template>
                    </rkm-input-group>
                </rkm-form-group>
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-group
                    class="my-0"
                    label-cols="auto"
                    label="Ordenar"
                >
                    <rkm-input-group>
                        <rkm-form-select
                            :options="sortOptions"
                            v-model="context.sortBy"
                            show-default-option
                        />

                        <template slot="append">
                            <rkm-form-select
                                v-model="context.sortDesc"
                            >
                                <rkm-form-select-option :value="false">Asc</rkm-form-select-option>
                                <rkm-form-select-option :value="true">Desc</rkm-form-select-option>
                            </rkm-form-select>
                        </template>
                    </rkm-input-group>
                </rkm-form-group>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-list-group>
                    <template v-if="busy">
                        <rkm-list-group-item class="text-center">
                            <rkm-row>
                                <rkm-col>
                                    <b-spinner
                                        label="Carregando..."
                                        small
                                        variant="primary"
                                    />
                                </rkm-col>
                            </rkm-row>
                        </rkm-list-group-item>
                    </template>

                    <template v-else>
                        <template v-if="internalItems.length > 0">
                            <div
                                v-for="(item, i) in hidePagination ? internalItems : internalItems.slice((context.currentPage - 1) * context.perPage, context.currentPage * context.perPage)"
                                v-bind:key="i"
                                :class="i === internalItems.length - 1 ? '' : 'mb-1'"

                            >
                                <rkm-list-group-item
                                    class="rkm-list-group-item"
                                    v-b-toggle="$scopedSlots.collapse ? 'rkm-collapse-' + i : null"
                                    :style="item._listItemStyle ? item._listItemStyle : ''"
                                    :color="item._listItemColor || 'none'"
                                >
                                    <rkm-row class="align-items-center">
                                        <rkm-col
                                            v-if="$scopedSlots.leading"
                                            cols="auto"
                                        >
                                            <slot
                                                name="leading"
                                                v-bind:item="item"
                                                v-bind:index="i"
                                            />
                                        </rkm-col>

                                        <rkm-col class="flex-grow-1">
                                            <slot v-bind:item="item" v-bind:index="i" />
                                        </rkm-col>

                                        <rkm-col
                                            v-if="$scopedSlots.trailling"
                                            cols="auto"
                                        >
                                            <slot
                                                name="trailling"
                                                v-bind:item="item"
                                            />
                                        </rkm-col>
                                    </rkm-row>
                                </rkm-list-group-item>

                                <rkm-collapse
                                    v-if="$scopedSlots.collapse"
                                    :id="'rkm-collapse-' + i"
                                    :visible="item.collapse"
                                    accordion="rkm-collapse"
                                    class="rkm-collapse"
                                >
                                    <slot
                                        name="collapse"
                                        v-bind:item="item"
                                        v-bind:index="i"
                                    />
                                </rkm-collapse>
                            </div>
                        </template>

                        <template v-else>
                            <rkm-list-group-item class="text-center">
                                <rkm-row>
                                    <rkm-col>
                                        Não há registros correspondentes à sua solicitação
                                    </rkm-col>
                                </rkm-row>
                            </rkm-list-group-item>
                        </template>
                    </template>
                </rkm-list-group>
            </rkm-col>
        </rkm-row>

        <rkm-row
            v-if="!hidePagination"
            class="mt-2"
        >
            <rkm-col class="my-1">
                <rkm-row class="align-items-center">
                    <rkm-col cols="auto">
                        <b-pagination
                            :per-page="context.perPage"
                            :total-rows="recordsFiltered"
                            class="my-0"
                            v-model="context.currentPage"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-col>

            <rkm-col
                class="my-1"
                cols="auto"
            >
                <rkm-form-group
                    class="m-0"
                    label-align="left"
                    label-cols="auto"
                    label="Por página"
                >
                    <rkm-form-select
                        :options="pageOptions"
                        v-model="context.perPage"
                    />
                </rkm-form-group>
            </rkm-col>
        </rkm-row>
    </component>
</template>

<script>
export default {
    computed: {
        sortOptions() {
            return this.fields.filter(field => !!field.sortable).map(field => {
                return { text: field.label, value: field.key }
            })
        },
    },
    data: () => ({
        busy: false,
        context: {
            currentPage: 1,
            filter: '',
            perPage: 5,
            sortBy: null,
            sortDesc: false,
        },
        internalItems: [],
        pageOptions: [5, 10, 15],
        recordsFiltered: 0,
        recordsTotal: 0,
    }),
    methods: {
        async datatable() {
            if (this.context.filter === null) {
                this.internalItems = []
                this.recordsFiltered = 0
                this.recordsTotal = 0
            } else {
                try {
                    this.busy = true

                    const params = {
                        draw: this.context.filter.length,
                        search: { value: this.context.filter },
                        columns: this.fields.filter(column => column.searchable).map(column => ({
                            name: column.key,
                            orderable: !!column.sortable,
                            search: { value: column.search || '' },
                            searchable: !!column.searchable,
                        })),
                        start: (this.context.currentPage - 1) * this.context.perPage,
                        length: this.context.perPage,
                    }

                    await this.repository.datatable({ ...params })
                        .then(response => {
                            this.internalItems = response.data
                            this.recordsFiltered = response.recordsFiltered
                            this.recordsTotal = response.recordsTotal
                        })
                } catch (error) {
                    this.handleError(error)
                } finally {
                    this.busy = false
                }
            }
        },
    },
    mounted() {
        this.internalItems = this.items
    },
    props: {
        fields: { type: Array, default: () => [] },
        hideFilters: { type: Boolean, default: false },
        hidePagination: { type: Boolean, default: false },
        items: { type: Array, default: () => [] },
        repository: { type: Object },
        tag: { type: String, default: 'div' },
    },
    watch: {
        context: {
            deep: true,
            handler(value) {
                if (this.repository) {
                    this.datatable()
                } else {
                    this.internalItems = this.items
                        .filter(item => {
                            for (let key in item) {
                                if (key === 'collapse')
                                    return false

                                if (item[key].toUpperCase().includes(value.filter.toUpperCase()))
                                    return true
                            }

                            return false
                        })
                        .sort((a, b) => {
                            if (value.sortDesc) {
                                if (a[value.sortBy] < b[value.sortBy]) {
                                    return 1
                                }
                            } else {
                                if (a[value.sortBy] > b[value.sortBy]) {
                                    return 1
                                }
                            }

                            return -1
                        })
                }
            },
        },
        internalItems(value) {
            this.recordsFiltered = value.length
        },
        items: {
            deep: true,
            handler(value) {
                this.internalItems = value
            }
        },
    }
}
</script>

<style scoped>
.rkm-list-group-item {
    padding: 0.75rem 1.25rem;
}
.rkm-list-group-item:focus {
    outline: none;
}
.rkm-list-group-item:first-child {
    border-radius: 0;
}
.rkm-list-group-item:last-child {
    border-radius: 0;
}
.rkm-list-group-item > .row {
    margin: 0;
}
.rkm-collapse {
    border-left: 1px solid rgba(0, 0, 0, .15);
    border-right: 1px solid rgba(0, 0, 0, .15);
    border-bottom: 1px solid rgba(0, 0, 0, .15);
}
</style>